import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { collectBrowserDiagnostics } from '@/utils/appVersion';
import { logger } from '@/utils/logger';

/** #1304: one-click diagnostics (build id, UA, online, route) for support. */
export function useCopyDiagnostics() {
    return useCallback(async () => {
        const text = collectBrowserDiagnostics();
        try {
            await navigator.clipboard.writeText(text);
            toast.success('Diagnostics copied — paste them into your report.');
        } catch (error: unknown) {
            logger.warn('Clipboard write failed for diagnostics', { error: error instanceof Error ? error.message : String(error) });
            toast.info(text, { autoClose: false });
        }
    }, []);
}
